import React, { memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SpriteIconWeb } from "@swiggy-private/dls-web-icons/dist/SpriteIconWeb";
import { STATIC_TEXTS } from "@cart-client/constants/GiftingCart";
import { HeaderCTAWrapper, HeaderCTAIconWrapper } from "./styles";

interface HeaderCTAProps {
    text?: string;
    onClick?: () => void;
}

const HeaderCTA = ({ text = STATIC_TEXTS.REMOVE_ALL, onClick }: HeaderCTAProps) => {
    return (
        <HeaderCTAWrapper>
            <Text variant="V2.body2.neutral.bold" color="text_Low_Emphasis" onClick={onClick}>
                {text}
                <HeaderCTAIconWrapper>
                    <SpriteIconWeb iconName="close12" fillColor="text_Low_Emphasis" strokeColor="text_Low_Emphasis" />
                </HeaderCTAIconWrapper>
            </Text>
        </HeaderCTAWrapper>
    );
};

export default memo(HeaderCTA);
